import getPriceLabelStringUtil from 'utils/string/get-price-label'
import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'
import getUnlockOnLabelProductUtil from 'modules/product/utils/get-unlock-on-label'
import isAvailableProductVariantUtil from 'modules/product-variant/utils/is-available'
import isAvailableRawProductVariantUtil from 'modules/product-variant/utils/is-available-raw'

const ADD_TO_GIFT_SET = 'Add to gift set'
const ADD_TO_CART = 'Add to cart'
const ALREADY_SAMPLED = 'Already sampled'
// const SIGN_UP_TO_SAMPLE = 'Sign up to sample'
const ADDED = 'Added'
const RATE_IT = 'Rate it'
const VIEW_OPTIONS = 'View options'
const OUT_OF_STOCK = 'Out of stock'
const UNLOCK = 'Unlock'
const LOADING = 'Loading...'

/**
 * @param {getByVariantIdAddLabelSelectorUtilProps} props
 * @returns {*}
 */
export default function getByVariantIdAddLabelSelectorUtil ({
  isLoading,
  isInCart,
  price,
  isSelectedVariantOutOfStock,
  isGiftCard,
  giftCardItem,
  isFromGrid,
  amount,
  discountPrice,
  isGifting,
  isUnlocked,
  isSmallScreen,
  isFromSidebar,
  isSelfGifting,
  hasExpressCheckout,
  hasSampled,
  hasSampledAndRated,
  shouldShowVariants = true,
  needsToBeRatedSample = false,
  shouldShowQuickShades,
  productVariant,
  shouldShowAOVLock,
  ...rest
}) {
  let isAvailable
  if (rest.isAvailable != null) {
    isAvailable = rest.isAvailable
  } else if (shouldShowQuickShades) {
    isAvailable = (
      isAvailableRawProductVariantUtil(productVariant) ||
      rest.isAvailableState
    )
  } else {
    isAvailable = (
      isAvailableProductVariantUtil(productVariant) ||
      rest.isAvailableState
    )
  }

  const shouldLog = productVariant?.product_id === 8769316552924
  const debugProps = {
    productVariant,
    isAvailable,
    hasSampled,
    hasSampledAndRated
  }
  shouldLog && logUtil('getByVariantIdAddLabelSelectorUtil').debug('[start] debugProps=', debugProps)

  const productLoyaltyTierName = productVariant?.lyt_tier
  const shouldUnlockSample = (
    !isGifting &&
    productLoyaltyTierName &&
    !isUnlocked
  )

  let label
  if (isLoading) {
    label = LOADING
  } else if (
    isInCart ||
    (
      isFromGrid &&
      isGiftCard &&
      giftCardItem
    )
  ) {
    label = ADDED
  } else if (
    needsToBeRatedSample &&
    hasSampled
  ) {
    label = RATE_IT
  } else if (hasSampledAndRated) {
    label = ALREADY_SAMPLED
  } else if (hasSampled) {
    label = ALREADY_SAMPLED
  } else if (
    isGiftCard &&
    !isFromGrid
  ) {
    label = `${ADD_TO_CART} · ${getPriceLabelStringUtil(amount, { ignoreZeroDecimals: true })}`
  } else if (
    // Live data
    isAvailable === false ||
    // This is using the cache, so it can be out of sync with the real data
    (
      isFromSidebar &&
      isSelectedVariantOutOfStock
    )
  ) {
    label = OUT_OF_STOCK
  } else if (
    !shouldShowQuickShades &&
    !shouldUnlockSample &&
    getVariantsProductVariantUtil(productVariant)?.length &&
    shouldShowVariants
  ) {
    label = VIEW_OPTIONS
  } else if (
    isSelfGifting &&
    hasExpressCheckout
  ) {
    label = ADD_TO_CART
  } else if (
    shouldUnlockSample &&
    isSmallScreen
  ) {
    label = UNLOCK
  } else if (shouldUnlockSample) {
    label = getUnlockOnLabelProductUtil(productLoyaltyTierName)
  } else if (
    isGifting &&
    price
  ) {
    label = `${ADD_TO_GIFT_SET} · ${getPriceLabelStringUtil(price)}`
  } else if (
    discountPrice &&
    discountPrice < price
  ) {
    label = `${ADD_TO_CART} · ${getPriceLabelStringUtil(discountPrice)}`
  } else if (
    price
  ) {
    label = `${ADD_TO_CART} · ${getPriceLabelStringUtil(price)}`
  } else if (isGifting) {
    label = ADD_TO_GIFT_SET
  } else if (shouldShowAOVLock) {
    label = UNLOCK
  } else {
    label = ADD_TO_CART
  }

  return label
}
